import { useEffect, useMemo, useState } from "react";
import { Option } from "../../../types/types";
import useApi from "../useApi";
import { master_baseUrl } from "../../webservice/Webservice_url";

interface dataTypes {
  package_id: string;
  package_name: string;
  package_code: string;
  package_status: boolean;
  pkg_department_id: string;
  department_id: string;
  mapping_status: boolean;
}

// departments by program id
export function usePackageByDepartmentId(
  departmentId: string,
  selectedPackageId?: string,
) {
  const [dataList, setDataList] = useState<dataTypes[]>([]);

  // API
  const { callApi, loading, error } = useApi<any>("", {
    method: "GET",
    autoCall: false,
    handleGlobalError: false,
  });

  const options = useMemo<Option[] | []>(() => {
    if (!dataList?.length) return [];

    return dataList?.map((d) => ({
      label:
        d?.package_name,
      value: d?.package_id ?? "",
    }));
  }, [dataList]);

  //   fetch data
  const fetchData = async () => {
    try {
      const res = await callApi(
        undefined,
        `${master_baseUrl}/departments/${departmentId}/packages`,
      );
      setDataList(Array.isArray(res) ? res : (res?.data ?? []));
    } catch (err: any) {
      setDataList([]);
      console.error(err);
    }
  };

  useEffect(() => {
    if (!departmentId) {
      setDataList([]);
      return;
    }
    fetchData(); 
  }, [departmentId]);
 
  const selectedItem = useMemo<any>(() => {
    if (!selectedPackageId) return null;
    return dataList.find((d) => d.package_id === selectedPackageId) ?? null;
  }, [dataList, selectedPackageId]);
 
  return { dataList, options, loading, selectedItem };
}
